import Factory from "../Factory";
import { FactoryInterface } from "../FactoryInterface";

import { Unit } from "../Entities/Unit/Unit";
import { UnitInterface } from "../Entities/Unit/UnitInterface";
import { AttachmentInterface } from "../Entities/Attachment/AttachmentInterface";
import AttachmentFactory from "./AttachmentFactory";
import Store from "../../Store/Store";

class UnitFactory extends Factory implements FactoryInterface {

  public create(data: any): UnitInterface {
    const attachments: AttachmentInterface[] = AttachmentFactory.createFromArray(data.attachments);
    return new Unit({
      id: data.id,
      unitNumber: data.unitNumber,
      avatar: this.getAvatar(attachments, "unit"),
      createdBy: data.createdBy,
      updatedBy: data.updatedBy,
      name: data.name,
      contractIds: this.getContracts(data.contracts),
      squareMeters: data.squareMeters,
      roomNumber: data.roomNumber,
      bedroomNumber: data.bedroomNumber,
      bathroomNumber: data.bathroomNumber,
      description: data.description,
      publicationTitle: data.publicationTitle,
      publicationDescription: data.publicationDescription,
      attachments: attachments,
      propertyId: data.propertyId,
      type: Store.getConfigurator().getState().globalTypes?.UnitType?.[data.unitTypeId],
      displayName: data.displayName,
      updatedAt: new Date(data.updatedAt),
      removed: data.removed,
      note: data.note,
      planningData: JSON.parse(data.planningData),
      unitStatusId: data.unitStatusId,
      paidStatusId: data.paidStatusId,
      countOfUnfinishedTasks: data.countOfUnfinishedTasks,
      countOfOverdueTasks: data.countOfOverdueTasks,
      rentUpdateDate: data.rentUpdateDate === null ? null : new Date(data.rentUpdateDate),
      unitServiceStatus: Store.getConfigurator().getState().globalTypes?.UnitServiceStatus?.[data.serviceStatusId],
      existsActiveAgencyFees: data.existsActiveAgencyFees,
      hasMemos: data.hasMemos,
      isNeedToAdjustRent: data.isNeedToAdjustRent,
      shortDisplayName: data.shortDisplayName
    });
  }

  public reinitialize(data: any): UnitInterface {
    return new Unit({
      ...data,
      avatar: this.getAvatar(data.attachments, "unit"),
    });
  }
}

export default new UnitFactory();
